import { PluginFunction } from 'vue';

import { store, Store as StoreObject } from '../store';

export const Store: PluginFunction<never> = (Vue) => {
	Vue.prototype.$store = store;
}

declare module "vue/types/vue" {
	interface Vue {
		$store: StoreObject;
	}
}
